import { AttributablePay } from '@fora-monorepo/employer-my-pages-common/types';

export const isPayAmountSameOrLargerThanAttributableTotal = (
  payAmount: number | null,
  attributablePay: AttributablePay
) => {
  const totalAttributableAmount = attributablePay.reduce((total, pay) => total + pay.attributablePayAmount, 0);
  return Boolean(payAmount !== null && totalAttributableAmount <= payAmount);
};
